import React from 'react';
import type { SxProps } from '@mui/material';
import { Chip } from '@mui/material';

import palette from 'ui/theme/palette';

export interface PillProps {
  text: string;
  onDelete?: () => void;
  dataCy?: string;
  dataCyDelete?: string;
  size?: 'small' | 'medium';
  style?: 'primary' | 'info' | 'warning' | 'error' | 'grey';
  icon?: React.ReactElement;
  sx?: SxProps;
}

// forwardRef + rest spread let wrappers like Tooltip attach their ref and event handlers
export const Pill = React.forwardRef<HTMLDivElement, PillProps>(function Pill(props, ref) {
  const { text, onDelete, dataCy, dataCyDelete, size, style, icon, sx, ...rest } = props;
  let backgroundColor, color;

  if (style === 'primary') {
    color = palette.primary.main;
    backgroundColor = palette.primary.light;
  } else if (style === 'info') {
    color = palette.info.main;
    backgroundColor = palette.info.notice;
  } else if (style === 'warning') {
    color = palette.warning.text;
    backgroundColor = palette.warning.light;
  } else if (style === 'error') {
    color = palette.error.main;
    backgroundColor = palette.error.background;
  } else if (style === 'grey') {
    color = palette.text.primary;
    backgroundColor = palette.text.disabled;
  }

  return (
    <Chip
      {...rest}
      ref={ref}
      label={text}
      onDelete={onDelete}
      variant="outlined"
      data-cy={dataCy}
      size={size ?? 'medium'}
      icon={icon}
      deleteIcon={
        <span
          className="material-icons"
          style={{
            color: palette.primary.main,
            width: '16px',
            fontSize: '10px',
            fontWeight: 'bold'
          }}
          data-cy={dataCyDelete}
        >
          clear_rounded
        </span>
      }
      sx={{
        color,
        backgroundColor,
        '& .MuiChip-icon': { color: 'inherit' },
        fontSize: size === 'small' ? '12px' : undefined,
        ...sx
      }}
    ></Chip>
  );
});
